export default __webpack_public_path__ + "static/media/airtel_icon.4c1f0633.png";